import {
  $convertFromMarkdownString,
  type Transformer,
} from "@lexical/markdown";
import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { ImportIcon } from "lucide-react";
import { useState } from "react";

import { Button } from "@/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
} from "@/components/ui/dialog";
import { Textarea } from "@/components/ui/textarea";

export function MarkdownImportPlugin({
  transformers,
}: {
  transformers: Array<Transformer>;
}) {
  const [editor] = useLexicalComposerContext();
  const [markdown, setMarkdown] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const handleImport = () => {
    editor.update(() => {
      $convertFromMarkdownString(markdown, transformers);
    });
    setMarkdown("");
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogTrigger asChild>
        <Button
          type="button"
          variant="ghost"
          title="Import from Markdown"
          aria-label="Import from markdown"
          size="sm"
          className="p-2"
        >
          <ImportIcon className="size-4" />
        </Button>
      </DialogTrigger>
      <DialogContent className="flex max-h-[90vh] flex-col sm:max-w-[600px]">
        <DialogHeader>
          <DialogTitle>Markdown İçe Aktar</DialogTitle>
          <DialogDescription>
            Markdown formatındaki metninizi buraya yapıştırın. Mevcut içeriğin
            devamına eklenecektir.
          </DialogDescription>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto py-4">
          <Textarea
            value={markdown}
            onChange={(e) => setMarkdown(e.target.value)}
            placeholder="# Başlık&#10;&#10;İçeriğinizi buraya yazın..."
            className="h-full min-h-[300px] resize-none font-mono text-sm"
          />
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={() => setIsOpen(false)}>
            Vazgeç
          </Button>
          <Button onClick={handleImport} disabled={!markdown.trim()}>
            İçeri Aktar
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
